import { DataSurveyActions, GET_SURVEY_SUCCESS, GetSurveySuccessAction } from "../actions/data-survey.actions";

/**
 * Created by jahidul.hasan on 9/8/2019.
 */

export interface DataSurveyState {
  currentSurvey: any;
}

export const initialState: DataSurveyState = <DataSurveyState> {
    currentSurvey: null,
};

export function DataSurveyReducer(state = initialState, action: DataSurveyActions) {
  switch (action.type) {
    case GET_SURVEY_SUCCESS:
      const currentSurvey = (action as GetSurveySuccessAction).survey;
      console.log('get survey', currentSurvey);
      return {
        ...state,
        currentSurvey: currentSurvey
      };
    default:
      return state;
  }
}
